<template>
  <div>
    <div>
      <h4 class="title-color">New Miscellaneous Invoice</h4>
    </div>
    <div class="form-row">
      <div class="form-row-input align-content" style="width: 20%;">
        <label class="label-text">Application Type: Miscellaneous</label>
      </div>
      <div class="form-row-input" style="width: 33%;">
        <ejs-textbox float-label-type="Always" placeholder="Reference/PO#:"
          v-model="invoice.referencePO" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input align-content" style="width: 20%; display: flex;
          flex-direction: row; gap: 10px">
        <ejs-radiobutton ref="permit" name="isPermit" label="Permit"
          :checked="invoice.applicationRequest.isPermit" @change="isSiteOrPermit" />
        <ejs-radiobutton ref="site" label="Site" name="isPermit"
          :checked="!invoice.applicationRequest.isPermit"
          @change="isSiteOrPermit" />
      </div>
      <div v-show="invoice.applicationRequest.isPermit" class="form-row-input required-label"
        style="width: 33%; margin-right: 31px;">
        <scc-input-validator :rules="[requiredRule]" :value="invoice.applicationRequest.permitNo"
            @validate="(v) => (this.isPermitValid = v)">
        <ejs-autocomplete ref="permitNumberAutocomplete" :dataSource="permitList"
          placeholder="Permit Number:" :fields="{ value: 'permitDisplayText', text: 'permitDisplayText' }"
          :minLength="3" :change="onPermitSelection" float-label-type="Always"
          v-model="invoice.applicationRequest.permitNo">
        </ejs-autocomplete>
        </scc-input-validator>
      </div>
      <div v-show="!invoice.applicationRequest.isPermit" style="width: 33%;"
        class="form-row-input required-label">
        <scc-input-validator :rules="[requiredRule]" :value="invoice.applicationRequest.siteName"
            @validate="(v) => (this.isSiteValid = v)">
          <ejs-autocomplete ref="siteNumberAutocomplete" :dataSource="siteList"
            placeholder="Site Number:" :fields="{ value: 'siteName', text: 'siteName' }"
            :minLength="3" :change="onSiteChange" float-label-type="Always"
            v-model="invoice.applicationRequest.siteName">
          </ejs-autocomplete>
        </scc-input-validator>
      </div>
      <div v-if="invoice.applicationRequest.isPermit" class="form-row-input" style="width: 40%;">
        <ejs-textbox float-label-type="Always" placeholder="Site Name:"
          v-model="invoice.applicationRequest.siteName" :readonly="true" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input" style="width: 100%; display: flex;
        flex-direction: row; gap: 10px">
        <label class="label-text required-css">Bill Invoice To: </label>
        <ejs-radiobutton ref="owner" name="isApplicant" label="Site Owner/Site Contact" :value="false"
          :checked="!invoice.applicationRequest.misIsApplicant" @change="isOwnerOrApplicant()" />
        <div v-if="invoice.applicationRequest.isPermit" >
          <ejs-radiobutton ref="applicant" label="Applicant"
          name="isApplicant" :checked="invoice.applicationRequest.misIsApplicant" :value="true"
          @change="isOwnerOrApplicant()" />
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input" style="width: 49%;">
        <fieldset>
          <legend>
            <h5 class="title-color" style="margin: 0px;">Site Owner/Site Contact Details</h5>
          </legend>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">Number: {{ invoice.applicationRequest.ownerId }}</label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input" style="width: 49%">
              <label class="label-text">
                Company: {{ invoice.applicationRequest.ownerCompanyName }}</label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Contact: {{ invoice.applicationRequest.ownerName }}</label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Address: {{ invoice.applicationRequest.ownerAddress }}
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Email:<span v-show="!invoice.applicationRequest.misIsApplicant"
                class="required-css"></span>  {{ invoice.applicationRequest.ownerEmailAddress }}
              </label>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="form-row-input" style="width: 49%;">
        <fieldset>
          <legend>
            <h5 class="title-color" style="margin: 0px;">Applicant Details</h5>
          </legend>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">Company: 
              <span v-show="invoice.applicationRequest.isPermit">{{invoice.applicationRequest.applicantCompanyName}}</span>
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Contact: 
                <span v-show="invoice.applicationRequest.isPermit">{{ invoice.applicationRequest.applicantName }}</span>
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Address: 
                <span v-show="invoice.applicationRequest.isPermit">{{ invoice.applicationRequest.applicantCompanyAddress }}</span>
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Email:<span v-show="invoice.applicationRequest.misIsApplicant"
                class="required-css"></span> 
                <span v-show="invoice.applicationRequest.isPermit">{{ invoice.applicationRequest.applicantEmailAddress }}</span>
              </label>
            </div>
          </div>
          <!-- Added empty space to maintain the details design  -->
          <div class="form-row">
            <div class="form-row-input">
              &nbsp;
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input" style="width: 99%">
        <ejs-textbox float-label-type="Always" placeholder="Internal Comments:"
          v-model="invoice.applicationRequest.internalNotes" multiline="true" rows=2 />
      </div>
    </div>
    <div>
      <fieldset>
        <legend>
          <h5 class="title-color" style="margin: 0px;">Product Details</h5>
        </legend>
        <div v-show="isNewItem">
          <div class="form-row invoice">
            <div class="form-row-input required-label" style="width: 49%;">
              <scc-input-validator :rules="[requiredRule]" :value="productDetails.misProductId"
                @validate="(v) => (this.isProductValid = v)">
                <ejs-dropdownlist float-label-type="Always" :dataSource='productsList'
                  :fields="{ value: 'productId', text: 'productName' }" :change="onProductSelection"
                  placeholder='Product Type:' v-model='productDetails.misProductId'
                  sortOrder="Ascending">
                </ejs-dropdownlist>
              </scc-input-validator>
            </div>
            <div class="form-row-input required-label" style="width: 100%;">
              <scc-input-validator :rules="[requiredRule]"
                :value="productDetails.misDescription"
                @validate="(v) => (this.isDescValid = v)">
                <ejs-textbox float-label-type="Always" placeholder="Description:"
                  v-model="productDetails.misDescription" multiline="true"
                  :maxlength="500" rows=2 />
              </scc-input-validator>
            </div>
            <div style="width:20%;" class="form-row-input">
              <ejs-numerictextbox float-label-type="Always" placeholder="Fee Total:" format="C2"
                v-model="productDetails.regFee" :showSpinButton="false" :min="0" />
            </div>
            <div style="width:20%;" class="form-row-input">
              <ejs-numerictextbox float-label-type="Always" placeholder="Levy Total:" format="C2"
                v-model="productDetails.sccFee" :showSpinButton="false" :min="0" />
            </div>
            <div v-if="productDetails.chargeBy == 'Hour'" class="form-row-input"
              style="width: 20%;">
              <ejs-dropdownlist float-label-type="Always" :dataSource='hoursList'
                :change="onHourChange" placeholder='Hours:' v-model='productDetails.misHrAmount'>
              </ejs-dropdownlist>
            </div>
            <div class="form-row-input" style="width: 20%;"
              v-if="invoice.applicationRequest.permitID && productDetails.chargeBy == 'Percentage'">
              <!-- <scc-input-validator :rules="[requiredRule]"
                :value="productDetails.misPercentageAmount"
                @validate="(v) => (this.isPercentValid = v)"> -->
                <ejs-dropdownlist float-label-type="Always" :dataSource='percentageList'
                  :change="onPercentChange"
                  placeholder='Percentage(%):' v-model='productDetails.misPercentageAmount '>
                </ejs-dropdownlist>
              <!-- </scc-input-validator> -->
            </div>
          </div>
          <div class="form-row">
            <div style="width: 100%" class="align-right">
              <ejs-button type="submit" cssClass="e-info margin-button"
                v-on:click.native="onAddClick()">Add</ejs-button>
              <ejs-button type="button" cssClass="e-info margin-button"
                v-on:click.native="onCancelAddClick()">Cancel</ejs-button>
            </div>
          </div>
        </div>
        <div v-show="!isNewItem">
          <div class="form-row-input align-right" style="width: 100%">
            <ejs-button type="button" cssClass="e-link" v-on:click.native="onAddNewLineItemClick()">
              <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
              Add New Line Item
            </ejs-button>
          </div>
          <ejs-grid style="max-height: 200px; overflow-y: auto;" :dataSource="selectedProductList"
            ref="refProductList" :created="created" :enablePersistence="false"
            :selection-settings="selectionOptions" :commandClick="commandClick"
            :allowSorting="true" :allowPaging="true" :pageSettings="pageSettings">
            <e-columns>
              <!-- <e-column headerText="Action" width="10%"
              :commands="editCommand" textAlign="Left" /> -->
              <e-column :template='cTemplate' width="5%" headerText="#" textAlign="Left" />
              <e-column field="productType" width="23%" headerText="Product Type"
                textAlign="Left" />
              <e-column field="misDescription" width="22%" headerText="Description"
                textAlign="Left" />
              <e-column field="regFee" width="10%" headerText="Fee" textAlign="Left" />
              <e-column field="unit" width="10%" headerText="Unit" textAlign="Left" />
              <e-column field="sccFee" width="10%" headerText="Levy" textAlign="Left"/>
              <e-column field="totalFee" width="10%" headerText="Total" textAlign="Left" />
              <e-column headerText="Delete" width="10%"
                :commands="deleteCommand" textAlign="Left" />
            </e-columns>
          </ejs-grid>
        </div>
      </fieldset>

      <div class="form-row">
        <div class="form-row-input" style="width: 99%">
          <label class="label-text">Total Due: ${{ invoice.applicationRequest.totalAmount }}</label>
        </div>
      </div>
      <div class="form-row">
        <div style="width: 100%" class="align-right">
          <ejs-button type="button" cssClass="e-info margin-button"
            v-on:click.native="onResetClick()">Reset Form</ejs-button>
          <ejs-button type="submit" cssClass="e-info margin-button"
            v-on:click.native="onSaveClick()">Save</ejs-button>
          <ejs-button type="button" cssClass="e-info margin-button"
            v-on:click.native="onCancelClick()">Cancel</ejs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { DropDownListPlugin, AutoCompletePlugin } from '@syncfusion/ej2-vue-dropdowns';
import { mapGetters } from 'vuex';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import {
  GET_OPEN_PERMITS, GET_PRODUCTS_BY_CATEGORY,
  GET_PRICE_BY_PRODUCTID, SET_INVOICE,
} from '../store';

import { SET_SELECTED_USER } from "../../reports/store";
import SccInputValidator from '../../../components/base/scc-input-new-validator.vue';

Vue.use(TextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(AutoCompletePlugin);
Vue.use(DropDownListPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(GridPlugin);

export default {
  name: "miscellaneousInvoice",
  components: {
    SccInputValidator,
  },
  data() {
    return {
      cTemplate() {
        return {
          template: Vue.component('columnTemplate', {
            template: `<b> {{index}} </b>`,
            data() {
              return {
                data: {},
              };
            },
            computed: {
              index() {
                return (parseInt(this.data.index, 10) + 1);
              },
            },
          }),
        };
      },
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isNewItem: false,
      isPermitValid: false,
      isSiteValid: false,
      isClosedPermit: false,
      isProductValid: false,
      isDescValid: false,
      isPercentValid: false,
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      pageSettings: { pageSize: 10 },
      deleteCommand: [
        {
          type: "Delete",
          buttonOption: {
            cssClass: 'e-flat deletebtn',
            iconCss: 'e-delete e-icons',
          },
        },
      ],
      selectedPermit: null,
      invoice: {
        invoiceSourceType: 'Miscellaneous',
        referencePO: null,
        applicationRequest: {
          requestUserEmail: null,
          requestor: null,
          firstName: null,
          lastName: null,
          isPermit: true,
          permitID: null,
          applicantName: null,
          applicantCompany: null,
          ownerNumber: null,
          ownerName: null,
          internalNotes: null,
          totalAmount: 0.00,
          requestType: 'Miscellaneous',
          misIsApplicant: false,
          permitNo: null,
          siteName: null,
          municipality: null,
        },
        invoiceDetails: [],
      },
      productDetails: {
        fee: 0.00,
        regFee: 0.00,
        sccFee: 0.00,
        siteID: null,
        siteName: null,
        siteAddress: null,
        misProductId: null,
        misPriceId: null,
        misHrAmount: null,
        misTmsPermitId: null,
        misTmsPermitNo: null,
        chargeBy: null,
        productType: null,
        misDescription: null,
        misPercentageAmount: null,
        totalFee: 0,
      },
      hoursList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
        13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      percentageList: [5, 10, 15, 20, 25, 30, 35, 40, 45,
        50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],
      dialogObj: null,
      siteList: [],
      permitList: [],
      selectedProductList: [],
      spin: false,
    };
  },
  computed: {
    ...mapGetters({
      openPermits: 'openPermits',
      productsList: 'products',
    }),
  },
  methods: {
    async created() {
      await this.getOpenPermitList();
      await this.getProductsList();
    },
    async getOpenPermitList() {
      try {
        const openPermits = await this.$store.dispatch(GET_OPEN_PERMITS, null);
        this.getUniqueData(openPermits.data);
      } catch (err) {
        console.error(err);
      }
    },
    getUniqueData(data) {
      if (data) {
        // eslint-disable-next-line array-callback-return
        data.map(permit => {
          const currentData = permit;

          if (permit.permitID && (this.permitList.findIndex((item) => item.permitID === permit.permitID) < 0)) {
            currentData.permitDisplayText = `${permit.permitNo ?? ''} (${permit.permitID})`;
            this.permitList.push(currentData);
          }

          if (permit.siteID && (this.siteList.findIndex((item) => item.siteID === permit.siteID) < 0)) {
            this.siteList.push(currentData);
          }
        });
      }
    },
    async getProductsList() {
      try {
        const category = 'Miscellaneous Fee';
        await this.$store.dispatch(GET_PRODUCTS_BY_CATEGORY, category);
      } catch (err) {
        console.error(err);
      }
    },
    async getPriceByProductID(productId) {
      let priceDetails = null;
      try {
        priceDetails = await this.$store.dispatch(GET_PRICE_BY_PRODUCTID, productId);
      } catch (err) {
        console.error(err);
      }
      return priceDetails;
    },
    notify(type, message) {
      this.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    validateInvoice() {
      if (this.invoice.applicationRequest.isPermit) {
        this.isSiteValid = true;
        this.invoice.applicationRequest.permitNo = !this.invoice.applicationRequest.permitID
          ? '' : this.invoice.applicationRequest.permitNo;
      } else {
        this.isPermitValid = true;
        this.invoice.applicationRequest.siteName = !this.invoice.applicationRequest.siteID
          ? '' : this.invoice.applicationRequest.siteName;
      }
    },
    validateProduct() {
      this.productDetails.misProductId = !this.productDetails.misProductId
        ? '' : this.productDetails.misProductId;

      this.productDetails.misDescription = !this.productDetails.misDescription
        ? '' : this.productDetails.misDescription;
    },
    isOwnerOrApplicant() {
      this.invoice.applicationRequest.misIsApplicant = this.$refs.applicant?.$el.checked;
      this.ownerOrApplicantChange();
    },
    ownerOrApplicantChange() {
      if (this.invoice.applicationRequest.misIsApplicant) {
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.requestUserEmail = this.selectedPermit?.applicantEmailAddress ?? null;
        this.invoice.applicationRequest.requestor = this.selectedPermit?.applicantName ?? null;
        this.invoice.applicationRequest.firstName = this.selectedPermit?.applicantFirstName ?? null;
        this.invoice.applicationRequest.lastName = this.selectedPermit?.applicantLastName ?? null;
        this.invoice.applicationRequest.company = this.selectedPermit?.applicantCompanyName ?? null;
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.billingAddress = this.selectedPermit?.applicantCompanyAddress ?? null;
        this.invoice.applicationRequest.city = this.selectedPermit?.applicantCityName ?? null;
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.province = this.selectedPermit?.applicantProvinceName ?? null;
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.postalCode = this.selectedPermit?.applicantPostalCode ?? null;
      } else {
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.requestUserEmail = this.selectedPermit?.ownerEmailAddress ?? null;
        this.invoice.applicationRequest.requestor = this.selectedPermit?.ownerName ?? null;
        this.invoice.applicationRequest.firstName = this.selectedPermit?.ownerFirstName ?? null;
        this.invoice.applicationRequest.lastName = this.selectedPermit?.ownerLastName ?? null;
        this.invoice.applicationRequest.company = this.selectedPermit?.ownerCompanyName ?? null;
        this.invoice.applicationRequest.billingAddress = this.selectedPermit?.ownerAddress ?? null;
        this.invoice.applicationRequest.city = this.selectedPermit?.ownerCityName ?? null;
        this.invoice.applicationRequest.province = this.selectedPermit?.ownerProvinceName ?? null;
        this.invoice.applicationRequest.postalCode = this.selectedPermit?.ownerPostalCode ?? null;
      }

      if (this.selectedPermit && !this.invoice.applicationRequest.requestUserEmail) {
        this.notify('Error', 'Please make sure owner/applicant has a valid email.');
      }
    },
    isSiteOrPermit() {
      this.invoice.applicationRequest.isPermit = this.$refs.permit.$el.checked;
      if (!this.invoice.applicationRequest.isPermit
          && this.invoice.applicationRequest.misIsApplicant) {
        this.invoice.applicationRequest.misIsApplicant = false;
      }
      this.resetInvoice(false);
    },
    onSiteChange(e) {
      if (e && e.e) {
        this.setDetails(e.itemData);
      } else if (e?.e === undefined) {
        this.setDetails(null);
      }
    },
    onPermitSelection(e) {
      if (e && e.e) {
        this.setDetails(e.itemData);
      } else if (e?.e === undefined) {
        this.setDetails(null);
      }
    },
    setDetails(permit) {
      this.isClosedPermit = false;
      if (permit?.permitStatusType?.toLowerCase() === 'closed') {
        this.isClosedPermit = true;
        this.notify('Error', 'Miscellaneous fees cannot be added to a closed permit.');
        // eslint-disable-next-line no-param-reassign
        permit = null;
      }

      this.selectedPermit = permit;
      this.ownerOrApplicantChange();
      this.setOwnerAndApplicantDetails(permit);
    },
    setOwnerAndApplicantDetails(permit) {
      this.invoice.applicationRequest.applicantName = permit?.applicantName ?? null;
      this.invoice.applicationRequest.applicantCompanyName = permit?.applicantCompanyName ?? null;
      this.invoice.applicationRequest.applicantEmailAddress = permit?.applicantEmailAddress ?? null;
      // eslint-disable-next-line max-len
      this.invoice.applicationRequest.applicantCompanyAddress = permit?.applicantCompanyAddress ?? null;
      this.invoice.applicationRequest.ownerNumber = permit?.ownerContactID ?? null;
      this.invoice.applicationRequest.ownerName = permit?.ownerName ?? null;
      this.invoice.applicationRequest.ownerAddress = permit?.ownerAddress ?? null;
      this.invoice.applicationRequest.ownerEmailAddress = permit?.ownerEmailAddress ?? null;
      this.invoice.applicationRequest.ownerCompanyName = permit?.ownerCompanyName ?? null;
      this.invoice.applicationRequest.siteID = permit?.siteID ?? null;
      this.invoice.applicationRequest.siteName = permit?.siteName ?? null;
      this.invoice.applicationRequest.siteAddress = permit?.siteAddress ?? null;
      this.invoice.applicationRequest.ownerId = permit?.ownerID ?? null;
      this.invoice.applicationRequest.ownerContactId = permit?.ownerContactID ?? null;
      this.invoice.applicationRequest.permitID = permit?.permitID ?? null;
      this.invoice.applicationRequest.municipality = permit?.municipalityName ?? null;
    },
    onAddNewLineItemClick() {
      this.validateInvoice();
      if (this.isPermitValid && this.isSiteValid) {
        this.isNewItem = true;
      } else {
        this.notify('Error', 'Please fill out required fields and try again.');
      }
    },
    async onProductSelection(e) {
      if (this.productDetails.misProductId) {
        const product = e?.itemData;
        this.productDetails.productType = product?.productDescription;
        this.productDetails.misPercentageAmount = null;
        this.productDetails.kilometres = null;
        this.productDetails.misHrAmount = null;
        this.productDetails.fee = 0.00;
        this.productDetails.regFee = 0.00;
        this.productDetails.sccFee = 0.00;
        this.productDetails.misPriceId = null;
        this.productDetails.chargeBy = null;
        this.productDetails.siteID = this.invoice.applicationRequest.siteID;
        this.productDetails.siteName = this.invoice.applicationRequest.siteName;
        this.productDetails.totalFee = 0.00;
        this.productDetails.misDescription = null;

        // eslint-disable-next-line max-len
        this.productDetails.siteAddress = this.invoice.applicationRequest.siteAddress;

        if (this.invoice.applicationRequest.isPermit) {
          this.productDetails.misTmsPermitNo = this.invoice.applicationRequest.permitNo;
          this.productDetails.misTmsPermitId = this.invoice.applicationRequest.permitID;
        } else  {
          this.productDetails.misTmsPermitNo = null;
          this.productDetails.misTmsPermitId = null;
        }

        // eslint-disable-next-line max-len
        const priceDetails = await this.getPriceByProductID(this.productDetails.misProductId);
        if (priceDetails) {
          this.productDetails.sccFee = priceDetails?.amountLevy;
          // this.productDetails.tankTotal = priceDetails?.amountTank;
          this.productDetails.misPriceId = priceDetails?.priceId;
          this.productDetails.chargeBy = priceDetails.chargeBy;

          switch (this.productDetails.chargeBy) {
            case 'Hour':
              this.productDetails.fee = priceDetails?.amountApp;
              this.productDetails.misHrAmount = 1;
              this.onHourChange();
              break;
            case 'Percentage':
              this.productDetails.misPercentageAmount = priceDetails?.amountApp;
              this.onPercentChange();
              break;
            default:
              this.productDetails.regFee = priceDetails?.amountApp;
              break;
          }
        }
      }
    },
    onPercentChange() {
      if (this.productDetails?.misPercentageAmount
      && this.invoice.applicationRequest.permitID && this.selectedPermit?.feeAmount) {
        // eslint-disable-next-line max-len
        this.productDetails.regFee = (this.selectedPermit.feeAmount * this.productDetails.misPercentageAmount) / 100;
      }
    },
    onHourChange() {
      if (this.productDetails.misHrAmount
        && this.productDetails.fee) {
        this.productDetails.regFee = this.productDetails.fee * this.productDetails.misHrAmount;
      }
    },
    onAddClick() {
      this.validateProduct();
      const isValid = this.isProductValid && this.isDescValid; // && this.isPercentValid;
      if (isValid) {
        if (this.productDetails) {
          switch (this.productDetails.chargeBy) {
            case 'Hour':
              this.productDetails.unit = this.productDetails.misHrAmount;
              break;
            case 'Percentage':
              this.productDetails.unit = this.productDetails.misPercentageAmount
                ? `${this.productDetails.misPercentageAmount}%` : null;
              break;
            default:
              break;
          }

          this.productDetails.totalFee = this.productDetails.regFee
            + this.productDetails.sccFee;
          this.selectedProductList.push(this.productDetails);
          this.invoice.applicationRequest.totalAmount += this.productDetails.totalFee;

          this.$refs.refProductList.refresh();
          this.onCancelAddClick();
        }
      } else {
        this.notify('Error', 'Please fill out required product details and try again.');
      }
    },
    onCancelAddClick() {
      this.isNewItem = false;
      this.isProductValid = false;
      this.isDescValid = false;
      // this.isPercentValid = false;
      this.productDetails = {
        fee: 0.00,
        regFee: 0.00,
        sccFee: 0.00,
        siteID: null,
        siteName: null,
        siteAddress: null,
        misTmsPermitId: null,
        misTmsPermitNo: null,
        misProductId: null,
        misPriceId: null,
        misHrAmount: null,
        chargeBy: null,
        productType: null,
        misDescription: null,
        misPercentageAmount: null,
        kilometres: null,
        // tankTotal: 0,
        totalFee: 0,
      };
    },
    async onSaveClick() {
      this.validateInvoice();
      if (this.isClosedPermit) {
        this.notify('Error', 'Miscellaneous fees cannot be added to a closed permit. If miscellaneous fees need to be added to a closed permit, the permit MUST be reopened first.');
      } else if (this.selectedPermit && !this.invoice.applicationRequest.requestUserEmail) {
        this.notify('Error', 'Please add a valid email to owner/applicant and try adding the invoice again...');
      } else {
        const isValid = this.isPermitValid && this.isSiteValid;
        if (isValid) {
          try {
            const mapInvoiceDetails = this.selectedProductList.map((p) => ({
              regFee: p.regFee,
              sccFee: p.sccFee,
              siteID: p.siteID,
              siteName: p.siteName,
              siteAddress: p.siteAddress,
              misProductId: p.misProductId,
              misPriceId: p.misPriceId,
              misHrAmount: p.misHrAmount,
              misPercentageAmount: p.misPercentageAmount,
              misTmsPermitNo: p.misTmsPermitNo,
              misTmsPermitId: p.misTmsPermitId,
              misDescription: p.misDescription,
            }));

            if (mapInvoiceDetails?.length > 0) {
              this.invoice.invoiceDetails = mapInvoiceDetails;
              const data = JSON.parse(JSON.stringify(this.invoice));
              await this.$store.dispatch(SET_INVOICE, { data });
              await this.$store.commit(SET_SELECTED_USER, {
                selectedUser: {
                  email: this.invoice.applicationRequest.requestUserEmail,
                  ownerContactId: this.invoice.applicationRequest.ownerContactId,
                  ownerId: this.invoice.applicationRequest.ownerId,
                  userFullName: this.invoice.applicationRequest.requestor,
                },
              });
              this.notify('Success!', 'Invoice created successfully.');
              this.$router.push('/reports/transactions');
            } else {
              this.notify('Error', 'Please provide product details.');
            }
          } catch (err) {
            this.notify('Error', err.response.data.message);
          }
        } else {
          this.notify('Error', 'Please fill out required fields and try again.');
        }
      }
    },
    onCancelClick() {
      this.confirmCancel(false);
    },
    onResetClick() {
      this.confirmCancel(true);
    },
    resetInvoice(isButtonClick = true) {
      this.isNewItem = false;
      this.isClosedPermit = false;
      this.isSiteValid = false;
      this.isPermitValid = false;
      this.onCancelAddClick();

      if (isButtonClick) {
        this.invoice.applicationRequest.misIsApplicant = false;
      }
      this.invoice.referencePO = null;
      this.invoice.applicationRequest.permitNo = null;
      this.invoice.applicationRequest.siteName = null;
      this.invoice.applicationRequest.internalNotes = null;
      this.selectedPermit = null;
      this.ownerOrApplicantChange();
      this.setOwnerAndApplicantDetails(null);
      this.selectedProductList = [];
      this.invoice.applicationRequest.totalAmount = 0.00;
    },
    confirmCancel(isReset = false) {
      if (this.selectedPermit || this.selectedProductList.length > 0) {
        this.dialogObj = DialogUtility.confirm({
          title: 'Cancel Confirmation',
          content: 'All previously entered data will be lost. Are you sure you want to proceed?',
          okButton: { text: 'OK', click: this.cancelInvoice.bind(this, isReset) },
          cancelButton: { text: 'Cancel', click: this.hideDialog },
          showCloseIcon: true,
          closeOnEscape: true,
          animationSettings: { effect: 'Zoom' },
        });
      } else {
        if (isReset) {
          this.resetInvoice(isReset);
        } else {
          this.$router.push('/reports/transactions');
        }
      }
    },
    cancelInvoice(isReset) {
      this.resetInvoice(isReset);
      this.dialogObj.hide();
      if (!isReset) {
        this.$router.push('/reports/transactions');
      }
    },
    commandClick(args) {
      switch (args.commandColumn.type) {
        case 'Delete':
          this.dialogObj = DialogUtility.confirm({
            title: 'Delete Line Item',
            content: 'Are you sure you want to delete this line item?',
            okButton: { text: 'OK', click: this.deleteLineItem.bind(this, args) },
            cancelButton: { text: 'Cancel', click: this.hideDialog },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' },
          });
          break;
        default:
          break;
      }
    },
    deleteLineItem(args) {
      const index = this.selectedProductList.indexOf(args.rowData);
      if (index >= 0) {
        this.selectedProductList.splice(index, 1);
        this.invoice.applicationRequest.totalAmount -= args.rowData.totalFee;
        this.notify('Success!', 'Item deleted successfully.');
        this.$refs.refProductList.refresh();
      }
      this.hideDialog();
    },
    hideDialog() {
      this.dialogObj.hide();
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>
<style>
@import '../../../assets/styles/eservices-base.css';

.pt-15 {
  padding-top: 15px;
}

.label-text {
  font-size: 13px;
  font-weight: 400;
}

.invoice .form-row-input {
  padding-right: 15px;
}

.form-row-input.align-content {
  height: 55px;
  vertical-align: middle;
}
</style>
